const MinusIcon = ({ size = 24, className = "", ...props }) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 32 32" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <g clipPath="url(#clip0_1827_6663)">
        <foreignObject 
          x="-9.05275" 
          y="-9.05275" 
          width="50.1055" 
          height="50.1055"
        >
          <div 
            xmlns="http://www.w3.org/1999/xhtml" 
            style={{
              backdropFilter: 'blur(4.53px)',
              clipPath: 'url(#bgblur_1_1827_6663_clip_path)',
              height: '100%',
              width: '100%'
            }}
          />
        </foreignObject>
        <rect 
          data-figma-bg-blur-radius="9.05275" 
          x="0.5" 
          y="0.5" 
          width="31" 
          height="31" 
          rx="11.5" 
          fill="#9EA6B2" 
          fillOpacity="0.3" 
          stroke="url(#paint0_linear_1827_6663)"
        />
        <path 
          d="M7.51472 16.2042H24.4853" 
          stroke="#CCCCCC" 
          strokeWidth="4" 
          strokeLinecap="round" 
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="bgblur_1_1827_6663_clip_path" transform="translate(9.05275 9.05275)">
          <rect x="0.5" y="0.5" width="31" height="31" rx="11.5"/>
        </clipPath>
        <linearGradient 
          id="paint0_linear_1827_6663" 
          x1="2.25884" 
          y1="2.51674" 
          x2="29.0078" 
          y2="31.1176" 
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white"/>
          <stop offset="1" stopColor="white" stopOpacity="0"/>
        </linearGradient>
        <clipPath id="clip0_1827_6663">
          <rect width="32" height="32" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  );
};

export default MinusIcon;